/* src/app/shared/components/app-header/app-header.component.scss */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-thumb {
  background: #acacac;
  border-radius: 8px;
}
::-webkit-scrollbar-track {
}
body {
  scrollbar-face-color: #acacac;
  scrollbar-track-color: rgb(213.5, 213.5, 213.5);
}
:host {
  grid-area: header;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  border-bottom: 1px solid var(--color-divider);
  padding: 0.5em 1.8em;
  background: white;
}
:host::ng-deep .mat-menu-item {
  line-height: 35px;
  height: 35px;
}
:host::ng-deep .mat-menu-item > .mat-icon {
  margin-right: 0.25em;
}
:host::ng-deep .mat-menu-item > .mat-icon.icon-right {
  margin-right: 0;
  margin-left: auto;
}
:host::ng-deep .mat-form-field-wrapper,
:host::ng-deep .mat-menu-content:not(:empty) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
:host::ng-deep .nav__search {
  border-radius: 25px;
  padding: 0.5em 1em;
  min-width: 18em;
}
:host::ng-deep .nav__toggle-icon {
  color: #006BB6;
  margin-right: 1em;
  margin-top: -4px;
}
:host::ng-deep .nav__toggle-icon mat-icon svg line {
  stroke: #006BB6;
}
:host::ng-deep .notification-bell-icon {
  display: flex;
  flex-flow: column;
  margin-left: auto;
}
.action-menu-button {
  width: 172px;
  margin-left: 16px;
}
ngx-avatar {
  padding: 2px;
}
.account .mat-menu-content {
  display: flex;
  flex-flow: column;
}
.account__btn {
  font-weight: normal;
  color: black;
  padding: 0.3em 0.65em !important;
  margin-left: auto;
  height: auto !important;
  display: flex;
}
.account__btn-text {
  padding-right: 0.5em;
  font-family:
    "Libre Caslon Text",
    "Times New Roman",
    serif;
  font-size: 1rem;
}
.account__avatar {
  margin: 1em 0 !important;
}
.account__name {
  font-weight: bold;
  font-family:
    "Libre Caslon Text",
    "Times New Roman",
    serif;
  margin-top: 0.5em;
}
.account__email {
  font-size: 1rem;
}
.account__name,
.account__email {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.account__preferences {
  margin-top: 1.5em;
}
.account__select {
  display: flex;
  justify-content: center;
  margin: 0 0.8em;
}
.account__defaults-container {
  margin-bottom: 16px !important;
}
.account__defaults-title {
  font-family:
    "Libre Caslon Text",
    "Times New Roman",
    serif;
  font-size: 1rem;
  margin-bottom: 0.8em;
}
.account__defaults-btn {
  cursor: pointer;
  padding: 0 1em 1.5em 1.1em;
  margin-top: -0.5em;
  font-size: 1rem;
}
.account__defaults-btn:hover {
  font-weight: bold;
  text-decoration: none;
}
.account__defaults-btn-back {
  transform: scale(0.65);
  margin: -2px 8px 0 8px;
}
.account__logout-btn {
  justify-content: center;
  font-size: 1rem;
  color: #006BB6 !important;
}
.account__logout-btn * {
  font-weight: bold !important;
}
.account__logout-btn mat-icon {
  margin-right: 4px;
}
label.field-label {
  margin-left: 12px;
}
.select-option {
  font-size: 1rem;
}
.select__no-data {
  color: #616161;
  margin: 8px 0 16px 16px;
  font-style: italic;
}
.avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2px;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  text-transform: uppercase;
  color: rgb(255, 255, 255);
  background-color: rgb(25, 159, 255);
  font:
    18px/40px Helvetica,
    Arial,
    sans-serif;
}
.avatar_lg {
  width: 60px;
  height: 60px;
  font-size: 1.6em;
}
.env-notification {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #FFFFFF;
  padding: 8px;
  border-bottom: 1px solid #ccc;
  font-family:
    "Inter",
    Arial,
    sans-serif;
  font-size: 13px;
  background: #DB6161 0% 0% no-repeat padding-box;
  border-radius: 6px;
}
.env-notification .mat-icon {
  width: 25px;
  height: 22px;
  margin-right: 8px;
  opacity: 0.7;
}
.env-notification a {
  color: #FFFFFF;
  text-decoration: underline;
  font-weight: bold;
}
/*# sourceMappingURL=app-header.component.css.map */
